function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { createContext, useContext, useState, useCallback, useEffect, useMemo, useRef } from "react";
import useCheckout from "../../hooks/use-checkout";
import { unhandledError } from "../../utils/unhandled-error";
import { trackAddressEditDuringCardEntry } from "../../utils/event-tracking";
import { getDefaultInstrument, getIsInstrumentFeatureAvailable, isCardInstrument } from "../../components/payment/utils";
import { PaymentMethodId } from "../../components/payment/PaymentMethodId";

// eslint-disable-next-line @typescript-eslint/no-explicit-any

var PaymentContext = /*#__PURE__*/createContext(undefined);
export var PaymentProvider = function PaymentProvider(_ref) {
  var _selectedMethod$id, _selectedMethod$gatew;
  var children = _ref.children;
  var _useCheckout = useCheckout(),
    checkoutState = _useCheckout.checkoutState,
    checkoutService = _useCheckout.checkoutService;
  var data = checkoutState.data;
  var customer = data === null || data === void 0 ? void 0 : data.getCustomer();
  var config = data === null || data === void 0 ? void 0 : data.getConfig();
  var methods = useMemo(function () {
    var _data$getPaymentMetho;
    var allMethods = (_data$getPaymentMetho = data === null || data === void 0 ? void 0 : data.getPaymentMethods()) !== null && _data$getPaymentMetho !== void 0 ? _data$getPaymentMetho : [];
    return allMethods.filter(function (m) {
      return m.id !== PaymentMethodId.PaypalCommerceCreditCards;
    });
  }, [data]);

  // Shared state
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    selectedMethod = _useState2[0],
    setSelectedMethod = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    selectedInstrument = _useState4[0],
    setSelectedInstrument = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    defaultSelectedInstrument = _useState6[0],
    setDefaultSelectedInstrument = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isProcessingPayment = _useState8[0],
    setIsProcessingPayment = _useState8[1];
  var _useState9 = useState(null),
    _useState0 = _slicedToArray(_useState9, 2),
    orderErrors = _useState0[0],
    setOrderErrors = _useState0[1];
  var _useState1 = useState(true),
    _useState10 = _slicedToArray(_useState1, 2),
    isOpen = _useState10[0],
    setIsOpenState = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    isShippingOpen = _useState12[0],
    setIsShippingOpenState = _useState12[1];

  // Set when Shipping displaces an open Payment pane, so closing Shipping can
  // hand it back. The Pay button lives inside Payment, so a shopper returning
  // from an address edit would otherwise face a collapsed pane and no way to
  // pay until they find the "Edit" link.
  var paymentYieldedRef = useRef(false);

  // Mirrors read by the identity-stable `setIsShippingOpen`, which can't take
  // state as a dependency without churning every consumer holding the setter.
  var stripeMountedRef = useRef(false);
  var stripeCardStartedRef = useRef(false);
  var stripeCardCompleteRef = useRef(false);
  // Edge detection for the tracking beacon: the invalid-address effects re-open
  // Shipping while it's already open, which isn't a new detour.
  var shippingOpenRef = useRef(false);

  // Wrapped setters enforce mutual exclusion: only one of Payment /
  // Shipping can be expanded at a time. Exception below for a live card form.
  var setIsOpen = useCallback(function (next) {
    setIsOpenState(next);
    if (next) {
      setIsShippingOpenState(false);
      // Closing Shipping from this side too, so the edge detector doesn't miss
      // the shopper's next trip into the address form.
      shippingOpenRef.current = false;
    }
    // Driven straight at Payment, so there's no yielded pane left to restore.
    paymentYieldedRef.current = false;
  }, []);
  var setIsShippingOpen = useCallback(function (next) {
    setIsShippingOpenState(next);
    var opening = next && !shippingOpenRef.current;
    shippingOpenRef.current = next;
    if (next) {
      // A mounted card form keeps its pane. Exclusion exists so two tall
      // panes can't push the Pay button off-screen, but collapsing this one
      // hides the shopper's half-typed card AND its only CTA -- worse than
      // the scroll it saves, and the button pins to the viewport on mobile.
      var keepPane = stripeMountedRef.current;
      if (opening && keepPane) {
        trackAddressEditDuringCardEntry(checkoutService.getState().data, "address_edit_opened", {
          cardStarted: stripeCardStartedRef.current,
          cardComplete: stripeCardCompleteRef.current,
          paneKeptOpen: true
        });
      }
      if (keepPane) return;
      setIsOpenState(function (prev) {
        // Latch only, never clear: the invalid-address effects re-open
        // Shipping while it's already open, and reading `false` there would
        // silently drop a pending restore.
        if (prev) paymentYieldedRef.current = true;
        return false;
      });
      return;
    }
    if (paymentYieldedRef.current) {
      paymentYieldedRef.current = false;
      setIsOpenState(true);
    }
  }, [checkoutService]);
  var _useState13 = useState(false),
    _useState14 = _slicedToArray(_useState13, 2),
    instrumentsLoaded = _useState14[0],
    setInstrumentsLoaded = _useState14[1];
  var _useState15 = useState(false),
    _useState16 = _slicedToArray(_useState15, 2),
    loadingInstruments = _useState16[0],
    setLoadingInstruments = _useState16[1];
  var _useState17 = useState(false),
    _useState18 = _slicedToArray(_useState17, 2),
    cardInstrumentsLoaded = _useState18[0],
    setCardInstrumentsLoaded = _useState18[1]; // Track if card instruments have been loaded at least once
  var _useState19 = useState(false),
    _useState20 = _slicedToArray(_useState19, 2),
    showAddNewCard = _useState20[0],
    setShowAddNewCard = _useState20[1];
  var _useState21 = useState(true),
    _useState22 = _slicedToArray(_useState21, 2),
    isFormValid = _useState22[0],
    setIsFormValid = _useState22[1];
  var setFormValid = useCallback(function (next) {
    setIsFormValid(function (prev) {
      return prev === next ? prev : next;
    });
  }, []);

  // Refcounted register/unregister so transient remounts don't flicker
  // the consumer state off and on.
  var topStickyCountRef = useRef(0);
  var _useState23 = useState(false),
    _useState24 = _slicedToArray(_useState23, 2),
    topStickyMounted = _useState24[0],
    setTopStickyMounted = _useState24[1];
  var registerTopSticky = useCallback(function () {
    topStickyCountRef.current += 1;
    if (topStickyCountRef.current === 1) setTopStickyMounted(true);
  }, []);
  var unregisterTopSticky = useCallback(function () {
    topStickyCountRef.current = Math.max(0, topStickyCountRef.current - 1);
    if (topStickyCountRef.current === 0) setTopStickyMounted(false);
  }, []);
  var inlineBannerCountRef = useRef(0);
  var _useState25 = useState(false),
    _useState26 = _slicedToArray(_useState25, 2),
    inlineBannerMounted = _useState26[0],
    setInlineBannerMounted = _useState26[1];
  var registerInlineBanner = useCallback(function () {
    inlineBannerCountRef.current += 1;
    if (inlineBannerCountRef.current === 1) setInlineBannerMounted(true);
  }, []);
  var unregisterInlineBanner = useCallback(function () {
    inlineBannerCountRef.current = Math.max(0, inlineBannerCountRef.current - 1);
    if (inlineBannerCountRef.current === 0) setInlineBannerMounted(false);
  }, []);

  // Idempotent setter so observer-driven updates don't ping-pong renders.
  var _useState27 = useState(false),
    _useState28 = _slicedToArray(_useState27, 2),
    guestPayMounted = _useState28[0],
    setGuestPayMountedState = _useState28[1];
  var setGuestPayMounted = useCallback(function (next) {
    setGuestPayMountedState(function (prev) {
      return prev === next ? prev : next;
    });
  }, []);

  // Ref-held so running the guard never triggers a render; the boolean
  // mirror only flips on mount/unmount of the guest form so the Pay button
  // can decide whether to render its guidance overlay.
  var guestSubmitGuardRef = useRef(null);
  var _useState29 = useState(false),
    _useState30 = _slicedToArray(_useState29, 2),
    hasGuestSubmitGuard = _useState30[0],
    setHasGuestSubmitGuard = _useState30[1];
  var registerGuestSubmitGuard = useCallback(function (guard) {
    guestSubmitGuardRef.current = guard;
    setHasGuestSubmitGuard(!!guard);
  }, []);
  var runGuestSubmitGuard = useCallback(function () {
    var guard = guestSubmitGuardRef.current;
    return guard ? guard() : true;
  }, []);
  var _useState31 = useState(false),
    _useState32 = _slicedToArray(_useState31, 2),
    guestFieldsIncomplete = _useState32[0],
    setGuestFieldsIncompleteState = _useState32[1];
  var setGuestFieldsIncomplete = useCallback(function (next) {
    setGuestFieldsIncompleteState(function (prev) {
      return prev === next ? prev : next;
    });
  }, []);
  var _useState33 = useState(false),
    _useState34 = _slicedToArray(_useState33, 2),
    stripeMounted = _useState34[0],
    setStripeMountedState = _useState34[1];
  var setStripeMounted = useCallback(function (next) {
    stripeMountedRef.current = next;
    setStripeMountedState(function (prev) {
      return prev === next ? prev : next;
    });
  }, []);
  var _useState35 = useState(false),
    _useState36 = _slicedToArray(_useState35, 2),
    stripeCardComplete = _useState36[0],
    setStripeCardCompleteState = _useState36[1];
  var setStripeCardComplete = useCallback(function (next) {
    stripeCardCompleteRef.current = next;
    setStripeCardCompleteState(function (prev) {
      return prev === next ? prev : next;
    });
  }, []);
  var _useState37 = useState(false),
    _useState38 = _slicedToArray(_useState37, 2),
    stripeCardStarted = _useState38[0],
    setStripeCardStartedState = _useState38[1];
  var setStripeCardStarted = useCallback(function (next) {
    stripeCardStartedRef.current = next;
    setStripeCardStartedState(function (prev) {
      return prev === next ? prev : next;
    });
  }, []);
  var _useState39 = useState(0),
    _useState40 = _slicedToArray(_useState39, 2),
    stripeReinitNonce = _useState40[0],
    setStripeReinitNonce = _useState40[1];
  var requestStripeReinit = useCallback(function () {
    return setStripeReinitNonce(function (n) {
      return n + 1;
    });
  }, []);
  var _useState41 = useState(false),
    _useState42 = _slicedToArray(_useState41, 2),
    checkoutStartedTracked = _useState42[0],
    setCheckoutStartedTrackedState = _useState42[1];
  var setCheckoutStartedTracked = useCallback(function (next) {
    setCheckoutStartedTrackedState(function (prev) {
      return prev === next ? prev : next;
    });
  }, []);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  var mainFormRef = useRef(null);

  // Wrapper for setSelectedMethod. Clears any prior `orderErrors` so a
  // stale failure (e.g. wallet country-mismatch) doesn't linger above
  // the newly-active method's UI, and resets `showAddNewCard` when
  // switching off card.
  var handleSetSelectedMethod = useCallback(function (method) {
    setSelectedMethod(method);
    setOrderErrors(null);
    if ((method === null || method === void 0 ? void 0 : method.gateway) !== PaymentMethodId.StripeV3) {
      setShowAddNewCard(false);
    }
  }, []);

  // Initialize selected method when methods load
  useEffect(function () {
    if (methods.length > 0 && !selectedMethod) {
      setSelectedMethod(methods[0]);
      setIsOpen(!methods[0] || !!(customer !== null && customer !== void 0 && customer.isGuest));
    }
  }, [methods, selectedMethod, customer === null || customer === void 0 ? void 0 : customer.isGuest]);

  // Keep selected method valid if list changes
  useEffect(function () {
    if (selectedMethod && !methods.some(function (m) {
      return m.id === selectedMethod.id;
    })) {
      var _methods$;
      setSelectedMethod((_methods$ = methods[0]) !== null && _methods$ !== void 0 ? _methods$ : null);
    }
  }, [methods, selectedMethod]);
  var isInstrumentFeatureAvailable = useMemo(function () {
    return getIsInstrumentFeatureAvailable({
      config: config,
      customer: customer,
      paymentMethod: selectedMethod || {}
    });
  }, [config, customer, selectedMethod]);
  var instruments = useMemo(function () {
    var _ref2;
    return (_ref2 = selectedMethod ? data === null || data === void 0 ? void 0 : data.getInstruments(selectedMethod) : []) === null || _ref2 === void 0 ? void 0 : _ref2.filter(isCardInstrument);
  }, [data, selectedMethod]);

  // Check if user has saved card instruments (regardless of selected payment method)
  var hasSavedCardInstruments = useMemo(function () {
    var _data$getInstruments, _cardInstruments$leng;
    var cardMethod = methods.find(function (m) {
      return m.gateway === PaymentMethodId.StripeV3;
    });
    if (!cardMethod) return false;
    var cardInstruments = data === null || data === void 0 || (_data$getInstruments = data.getInstruments(cardMethod)) === null || _data$getInstruments === void 0 ? void 0 : _data$getInstruments.filter(isCardInstrument);
    return ((_cardInstruments$leng = cardInstruments === null || cardInstruments === void 0 ? void 0 : cardInstruments.length) !== null && _cardInstruments$leng !== void 0 ? _cardInstruments$leng : 0) > 0;
  }, [data, methods]);

  // Mark card instruments as loaded once we've checked them
  useEffect(function () {
    if (!cardInstrumentsLoaded && methods.length > 0) {
      var cardMethod = methods.find(function (m) {
        return m.gateway === PaymentMethodId.StripeV3;
      });
      if (cardMethod) {
        var cardInstruments = data === null || data === void 0 ? void 0 : data.getInstruments(cardMethod);
        // Only mark as loaded if we've actually received data (even if empty)
        if (cardInstruments !== undefined) {
          setCardInstrumentsLoaded(true);
        }
      }
    }
  }, [cardInstrumentsLoaded, data, methods]);
  var methodKey = "".concat((_selectedMethod$id = selectedMethod === null || selectedMethod === void 0 ? void 0 : selectedMethod.id) !== null && _selectedMethod$id !== void 0 ? _selectedMethod$id : "", "|").concat((_selectedMethod$gatew = selectedMethod === null || selectedMethod === void 0 ? void 0 : selectedMethod.gateway) !== null && _selectedMethod$gatew !== void 0 ? _selectedMethod$gatew : "");

  // Load instruments
  useEffect(function () {
    var cancelled = false;
    var run = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              setInstrumentsLoaded(false);
              if (selectedMethod) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              if (isInstrumentFeatureAvailable) {
                _context.n = 2;
                break;
              }
              setInstrumentsLoaded(true);
              return _context.a(2);
            case 2:
              setLoadingInstruments(true);
              _context.p = 3;
              _context.n = 4;
              return checkoutService.loadInstruments();
            case 4:
              if (!cancelled) setInstrumentsLoaded(true);
              _context.n = 6;
              break;
            case 5:
              _context.p = 5;
              _t = _context.v;
              unhandledError("Loading payment instruments", _t);
              if (!cancelled) setInstrumentsLoaded(true);
            case 6:
              _context.p = 6;
              if (!cancelled) setLoadingInstruments(false);
              return _context.f(6);
            case 7:
              return _context.a(2);
          }
        }, _callee, null, [[3, 5, 6, 7]]);
      }));
      return function run() {
        return _ref3.apply(this, arguments);
      };
    }();
    run();
    return function () {
      cancelled = true;
    };
  }, [methodKey, isInstrumentFeatureAvailable, checkoutService]);

  // Auto-select instrument when:
  // - Card method is selected
  // - No instrument currently selected
  // - Has saved instruments
  // - Not actively adding a new card
  useEffect(function () {
    var _instruments$length;
    if (!selectedMethod) return;
    var isStripeV3 = selectedMethod.gateway === PaymentMethodId.StripeV3;
    var count = (_instruments$length = instruments === null || instruments === void 0 ? void 0 : instruments.length) !== null && _instruments$length !== void 0 ? _instruments$length : 0;
    if (!instrumentsLoaded) {
      return;
    }

    // Clear instrument for non-card methods
    if (!isStripeV3) {
      setSelectedInstrument(null);
      return;
    }

    // Don't auto-select if user is adding a new card
    if (showAddNewCard) return;

    // Auto-select if no instrument is selected but we have saved instruments
    if (!selectedInstrument && count > 0) {
      var _ref4;
      var defaultInstrument = (_ref4 = getDefaultInstrument(instruments) || instruments[0]) !== null && _ref4 !== void 0 ? _ref4 : null;
      setSelectedInstrument(defaultInstrument);
      setDefaultSelectedInstrument(defaultInstrument);
    }
  }, [methodKey, instrumentsLoaded, instruments === null || instruments === void 0 ? void 0 : instruments.length, selectedMethod, instruments, selectedInstrument, showAddNewCard]);
  var handleSelectInstrument = useCallback(function (instrument) {
    setOrderErrors(null);
    setSelectedInstrument(instrument);
  }, []);
  var value = useMemo(function () {
    return {
      selectedMethod: selectedMethod,
      selectedInstrument: selectedInstrument,
      defaultSelectedInstrument: defaultSelectedInstrument,
      isProcessingPayment: isProcessingPayment,
      orderErrors: orderErrors,
      isOpen: isOpen,
      isShippingOpen: isShippingOpen,
      instrumentsLoaded: instrumentsLoaded,
      loadingInstruments: loadingInstruments,
      instruments: instruments,
      isInstrumentFeatureAvailable: isInstrumentFeatureAvailable,
      methods: methods,
      showAddNewCard: showAddNewCard,
      hasSavedCardInstruments: hasSavedCardInstruments,
      cardInstrumentsLoaded: cardInstrumentsLoaded,
      setSelectedMethod: handleSetSelectedMethod,
      setSelectedInstrument: setSelectedInstrument,
      setDefaultSelectedInstrument: setDefaultSelectedInstrument,
      setIsProcessingPayment: setIsProcessingPayment,
      setOrderErrors: setOrderErrors,
      setIsOpen: setIsOpen,
      setIsShippingOpen: setIsShippingOpen,
      setShowAddNewCard: setShowAddNewCard,
      mainFormRef: mainFormRef,
      isFormValid: isFormValid,
      setFormValid: setFormValid,
      topStickyMounted: topStickyMounted,
      registerTopSticky: registerTopSticky,
      unregisterTopSticky: unregisterTopSticky,
      inlineBannerMounted: inlineBannerMounted,
      registerInlineBanner: registerInlineBanner,
      unregisterInlineBanner: unregisterInlineBanner,
      guestPayMounted: guestPayMounted,
      setGuestPayMounted: setGuestPayMounted,
      registerGuestSubmitGuard: registerGuestSubmitGuard,
      runGuestSubmitGuard: runGuestSubmitGuard,
      hasGuestSubmitGuard: hasGuestSubmitGuard,
      guestFieldsIncomplete: guestFieldsIncomplete,
      setGuestFieldsIncomplete: setGuestFieldsIncomplete,
      stripeMounted: stripeMounted,
      setStripeMounted: setStripeMounted,
      stripeCardComplete: stripeCardComplete,
      setStripeCardComplete: setStripeCardComplete,
      stripeCardStarted: stripeCardStarted,
      setStripeCardStarted: setStripeCardStarted,
      stripeReinitNonce: stripeReinitNonce,
      requestStripeReinit: requestStripeReinit,
      checkoutStartedTracked: checkoutStartedTracked,
      setCheckoutStartedTracked: setCheckoutStartedTracked,
      handleSelectInstrument: handleSelectInstrument
    };
  }, [selectedMethod, selectedInstrument, defaultSelectedInstrument, isProcessingPayment, orderErrors, isOpen, isShippingOpen, setIsOpen, setIsShippingOpen, instrumentsLoaded, loadingInstruments, instruments, isInstrumentFeatureAvailable, methods, showAddNewCard, cardInstrumentsLoaded, hasSavedCardInstruments, handleSetSelectedMethod, handleSelectInstrument, isFormValid, setFormValid, topStickyMounted, registerTopSticky, unregisterTopSticky, inlineBannerMounted, registerInlineBanner, unregisterInlineBanner, guestPayMounted, setGuestPayMounted, registerGuestSubmitGuard, runGuestSubmitGuard, hasGuestSubmitGuard, guestFieldsIncomplete, setGuestFieldsIncomplete, stripeMounted, setStripeMounted, stripeCardComplete, setStripeCardComplete, stripeCardStarted, setStripeCardStarted, stripeReinitNonce, requestStripeReinit, checkoutStartedTracked, setCheckoutStartedTracked]);
  return /*#__PURE__*/React.createElement(PaymentContext.Provider, {
    value: value
  }, children);
};
export var usePayment = function usePayment() {
  var context = useContext(PaymentContext);
  if (!context) {
    // Return safe defaults when used outside PaymentProvider (e.g., OrderConfirmation)
    return {
      isProcessingPayment: false,
      setIsProcessingPayment: function setIsProcessingPayment() {},
      checkoutStartedTracked: false,
      setCheckoutStartedTracked: function setCheckoutStartedTracked() {}
    };
  }
  return context;
};